import React from "react"
import clsx from "clsx"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import { FaSignOutAlt } from "react-icons/fa"

import { logout } from "utils"
import navItems from "../../constants/navItems"
import classes from "./SideNavigation.module.scss"

const SideNavigation = (props) => {
  const { openSidebar } = props

  const { role, accesses } =
    useSelector(state => state.userAccountInfo)

  const location = useLocation()

  const navigate = useNavigate()

  const showNavItem = (item) => (
    accesses.hasFullAccess ||
    !!accesses[item.requiredAccess]
  )

  if (!role) return null

  return (
    <div
      className={clsx(classes["container"],
        openSidebar && classes["open"]
      )}
    >

      {navItems[role].map(navItem => (
        showNavItem(navItem) &&
        <Link
          key={navItem.path}
          className={clsx(classes["tab"],
            navItem.path === location.pathname && classes["active"])}
          to={navItem.path}
        >
          {navItem.icon}
          {navItem.title}
        </Link>
      ))}

      <div
        className={classes["tab"]}
        onClick={() => {
          logout()
          navigate("/")
        }}
      >
        <FaSignOutAlt />
        خروج
      </div>
    </div>
  )
}

export default SideNavigation